import { type IncompleteProfileBadge_profile$key } from '#app/__generated__/relay/IncompleteProfileBadge_profile.graphql.js';
import { useHasCompletedProfile } from '#app/hooks/useHasCompletedProfile.js';
import { useSelectedUserType } from '#app/hooks/useSelectedUserType.js';
import { IncompleteProfileButton } from './IncompleteProfileButton.js';
import { graphql, useFragment } from '@contra/relay';
import { styled } from 'styled-components';

const Container = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
`;

export const IncompleteProfileBadge = ({
  readonly = false,
  userProfileRef,
}: {
  readonly readonly?: boolean;
  readonly userProfileRef: IncompleteProfileBadge_profile$key;
}) => {
  const { isClient } = useSelectedUserType();
  const data = useFragment<IncompleteProfileBadge_profile$key>(
    graphql`
      fragment IncompleteProfileBadge_profile on UserProfile {
        visitorCanEdit
      }
    `,
    userProfileRef,
  );

  const hasCompletedIndyProfile = useHasCompletedProfile();

  if (!data.visitorCanEdit || hasCompletedIndyProfile || isClient) {
    return null;
  }

  return (
    <Container>
      <IncompleteProfileButton readonly={readonly} />
    </Container>
  );
};
